import React from "react"
import styled from "styled-components"
import { useQuery } from "@apollo/client"

import { COACH_TOOLS_API } from "../../../apolloClient"
import { MEMBER_APPLICATION_ELECTION_DATE_QUERY } from "../../queries/memberApplicationElectionDate"
import { RequirementDescription } from "../MembershipJourney/Styles/ProgressTracker.styles"
import { formatElectionDate } from "../../../utils/applicationElectionDate"
import {
  PTM_APPLICATION_TYPES,
  pickLatestApplicationForType,
} from "../../../utils/prospect/ptmApplicationStatus"

export const ELECTION_DATE_LABEL = "Scheduled Election Date:"

const ElectionDateLine = styled(RequirementDescription)`
  margin-top: 4px;
`

/**
 * One line under an approved Member application that says which election it
 * is scheduled for. Renders nothing until staff assign a date, once the
 * application has been elected, or when the query fails.
 */
const MemberApplicationElectionDate = ({ className }) => {
  const { data, error } = useQuery(MEMBER_APPLICATION_ELECTION_DATE_QUERY, {
    context: { api: COACH_TOOLS_API },
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  })

  if (error) return null

  const application = pickLatestApplicationForType(
    data?.membershipApplications,
    PTM_APPLICATION_TYPES.MEMBER,
  )
  if (
    String(application?.status || "").toLowerCase() !== "approved" ||
    application.electedAt
  ) {
    return null
  }

  const formatted = formatElectionDate(application.electionDate)
  if (!formatted) return null

  return (
    <ElectionDateLine
      className={className}
      data-testid="member-application-election-date"
    >
      {ELECTION_DATE_LABEL} <strong>{formatted}</strong>
    </ElectionDateLine>
  )
}

export default MemberApplicationElectionDate
